"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chipPropTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interactiveChip = require("./interactive-chip");

var _interfaces = require("./interfaces");

var _staticChip = require("./static-chip");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var chipPropTypes = _objectSpread(_objectSpread({
  backgroundColor: _stencilReactDesc.PropTypes.string.description('Sets the background color for the static chip. Does not affect the text color, so only colors with enough contrast should be used.'),
  children: _stencilReactDesc.PropTypes.node.description('Text to display in the chip.'),
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ChipColorScheme)).description('Selects a predefined color scheme to use for the component.'),
  icon: _stencilReactDesc.PropTypes.node.description('Adds an icon on the leading or trailing side of the chip.'),
  iconPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ChipIconPosition)).description('Determines on which side the icon would be placed.'),
  id: _stencilReactDesc.PropTypes.string.description("Sets the 'id' attribute in the DOM for the content."),
  size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ChipSize)).description('Specifies what size of the chip should be used.')
}, _interactiveChip.interactiveChipPropTypes), _staticChip.staticChipPropTypes);

exports.chipPropTypes = chipPropTypes;